import { render } from "./PlantActorForm.vue?vue&type=template&id=42272bbc&ts=true"
import script from "./PlantActorForm.vue?vue&type=script&lang=ts"
export * from "./PlantActorForm.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__